var _path, _path2, _rect, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4163 9.79175V10.4682C27.4163 11.7999 28.1768 13.0147 29.3747 13.5965V13.5965C30.5726 14.1783 31.333 15.3931 31.333 16.7248V25.962V28.972C31.333 29.4801 31.1274 29.9665 30.7629 30.3205V30.3205C30.0028 31.0589 30.0028 32.2793 30.7629 33.0177V33.0177C31.1274 33.3717 31.333 33.8582 31.333 34.3663V37.3366C31.333 37.8958 31.1995 38.447 30.9436 38.9442V38.9442C29.9802 40.8159 28.0516 41.9923 25.9464 41.9923H23.4997",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5832 9.79175V10.4682C19.5832 11.7999 18.8227 13.0147 17.6248 13.5965V13.5965C16.427 14.1783 15.6665 15.3931 15.6665 16.7248V25.962V28.972C15.6665 29.4801 15.8721 29.9665 16.2366 30.3205V30.3205C16.9967 31.0589 16.9967 32.2793 16.2366 33.0177V33.0177C15.8721 33.3717 15.6665 33.8582 15.6665 34.3663V37.3366C15.6665 37.8958 15.8 38.447 16.0559 38.9442V38.9442C17.0193 40.8159 18.9479 41.9923 21.0531 41.9923H23.4998",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.6042,
    y: 4.89591,
    width: 9.79167,
    height: 3.91667,
    rx: 0.979167,
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6665 16.646H31.3332",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6665 25.4585H31.3332",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/Water.30bb20301948626ace4ede150a802b46.svg";
export { ForwardRef as ReactComponent };